module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/tab-1-fb8c9b7445c4d21defa10b74d2cf7f62.png";